'use client';
import React, { createContext, useContext, useState, ReactNode } from 'react';

type VilleFilter = 'toutes' | 'Douala' | 'Abidjan';

interface VilleFilterContextType {
  villeFilter: VilleFilter;
  setVilleFilter: (ville: VilleFilter) => void;
}

const VilleFilterContext = createContext<VilleFilterContextType>({
  villeFilter: 'toutes',
  setVilleFilter: () => {},
});

export function VilleFilterProvider({ children }: { children: ReactNode }) {
  const [villeFilter, setVilleFilter] = useState<VilleFilter>('toutes');

  return (
    <VilleFilterContext.Provider value={{ villeFilter, setVilleFilter }}>
      {children}
    </VilleFilterContext.Provider>
  );
}

export function useVilleFilter() {
  return useContext(VilleFilterContext);
}
